import { type HeaderProps, HEADER_CONST } from './Header.d';
import { Header } from './Header.styles';

const HeaderBase = ({
  children,
  fixed = true,
  justify = 'space-between',
  topbar,
  ...props
}: HeaderProps) => (
  <>
    <Header.Component data-fixed={fixed} data-testid={HEADER_CONST.TEST_ID} {...props}>
      {topbar}
      {!!topbar && <Header.Divider />}
      <Header.Container aria-labelledby="menu-title" data-justify={justify}>
        {children}
      </Header.Container>
    </Header.Component>
    {fixed && <Header.Space />}
  </>
);

export default HeaderBase;
